import { Injectable } from "@angular/core";
@Injectable()
export class Product {
  name: string;
  picture: string;
  qte: number;
  type:string;
  available:boolean;
}
